import React from 'react'

function AddCashFormStyle() {
  return (
    <style jsx='true'>
    {`
      #add-cash-form-container {
        /*background-color: blue;*/
        display: flex;
        flex-direction: column;
        height: 100%;
      }

      .add-cash-input-wrapper {
        display: flex;
        flex-direction: column;
        height: 100%;
      }

      #add-cash-input-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
      }

      #add-cash-input {
        padding: 10px;
        flex: 1;
        text-align: center;
        font-size: 0.8em;
        font-weight: bold;
      }

      #action-button-container {
        flex: 1;
        margin-top: 10px;
        display: flex;
        justify-content: center;
      }
    `}
    </style>
  )
}

export default React.memo(AddCashFormStyle)
